class PredictiveSearchMobile extends PredictiveSearch {
  constructor() {
    super();
  }

  initSlider() {
    return;
  }

  clickOutside() {
    return;
  }

  open() {
    this.predictiveSearchResults.classList.add('is-open');

    bodyScroll.lock(this.predictiveSearchResults);
  }

  close(clearSearchTerm) {
    super.close(clearSearchTerm);

    const megamenu = this.closest('megamenu-element');

    if (megamenu && megamenu.classList.contains('is-open')) {
      bodyScroll.lock(megamenu.querySelector('[data-overflow]'));
    }
  }
}

customElements.define('predictive-search-mobile', PredictiveSearchMobile);
